'use client';

// Data
import { navButtons, footButtons } from '../../util/data/navButtons';

// Components
import Navlink from './Navlink';
import NavUser from './NavUser';
import NavNotifications from './NavNotifications';

// Icons
import AttikIcon from '../svg/AttikIcon';
import { useGlobalContext } from '../../app/tools/globalContext';
import OutsideAlerter from '@/util/OutsideAlerter';
import { SessionType } from '@/util/types/globalTypes';
import { FaStar } from 'react-icons/fa6';
import { UserSettings } from '@/util/types/serverTypes';
import FeatureBaseBtns from './FeatureBaseBtns';
export default function Navbar({
  session,
  userSettings,
}: {
  session: SessionType;
  userSettings: UserSettings | null;
}) {
  const { mobileMenuOpen, setMobileMenuOpen } = useGlobalContext();

  return (
    <OutsideAlerter isActive={mobileMenuOpen} outsideClickHandler={() => setMobileMenuOpen(false)}>
      <nav
        className={`
          group/navbar flex h-full w-16 flex-shrink-0 flex-col gap-4 overflow-hidden rounded-lg bg-themeBlack p-2 py-4
          text-sm text-gray-400 shadow-sm transition-all duration-400 ease-in-out md:hover:w-[200px]
          ${mobileMenuOpen ? '!left-0 !w-[200px]' : 'relative -left-[74px]'}
          md:!left-0 md:w-16
        `}
      >
        <div className='px-2'>
          <AttikIcon />
        </div>
        <div className='flex flex-auto flex-col gap-1 pb-1 pl-[0.4rem]'>
          {userSettings?.favorites && userSettings?.favorites.length > 0 && (
            <Navlink
              button={{
                label: 'Favorites',
                to: '/',
                permission: null,
                icon: <FaStar />,
                subnav: userSettings.favorites?.map((fav) => ({
                  label: fav.title,
                  to: fav.slug,
                  permission: null,
                })),
              }}
            />
          )}
          {navButtons
            .filter((btn) => {
              if (btn.permission === null) return true;
              if (Array.isArray(btn.permission)) {
                return btn.permission.some((p) => session?.user?.permissions.includes(p));
              }
              return session?.user?.permissions.includes(btn.permission);
            })
            .map((button) => (
              <Navlink button={button} key={button.to} />
            ))}
          <div className='flex-auto'></div>
          <NavNotifications />
          {/* {['settings-help-center', 'settings-admin', 'super-admin'].some((p) =>
            session?.user?.permissions?.includes(p)
          ) && <FeatureBaseBtns />} */}
          <Navlink button={footButtons[0]} />
          <NavUser session={session} />
        </div>
      </nav>
    </OutsideAlerter>
  );
}
